import { Button, Grid } from "@mui/material";
import {
  CreateButton,
  EditButton,
  ExportButton,
  FilterButton,
  isEmpty,
  SelectColumnsButton,
  ShowButton,
  useListPaginationContext,
  useNotify,
  useRecordContext,
  useRedirect,
} from 'react-admin'
import { ActionTitles, RESOURCES_BASEPATH } from '../Constants'
import { filterButton, pageTitle, topActionButtonBaseStyle, topActionButtonsRow } from '../Styles'
import { isAdminUser } from "../DataProvider";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined'
import ColorLensOutlinedIcon from '@mui/icons-material/ColorLensOutlined'
import CustomDeleteWithConfirmButton from '../../utils/CustomDeleteWithConfirmButton'
import { deleteCallback } from '../../utils/util'
import { useState } from 'react'
import { StatusMessageAlerts } from "./AlertComponent.jsx"
import { EastOutlined, WestOutlined } from "@mui/icons-material";

//receives title as a prop for displaying title depending upon page type
//set base path also based on props only
const ListActions = (props) => {
  const notify = useNotify();
  const redirect = useRedirect()
  const record = useRecordContext();
  const { previousClientRequestId, nextClientRequestId } = record ?? {};
  const paginationContext = useListPaginationContext();
  const isAdmin = isAdminUser();
  const isDisabled =
    isAdmin &&
    (props.title === ActionTitles.REPORTS ||
      props.title === ActionTitles.SCHEDULES ||
      props.title === ActionTitles.MATTERS ||
      props.title === ActionTitles.MATTER_DETAILS ||
      props.title === ActionTitles.IDENTITY_VERIFICATIONS || 
      props.title === ActionTitles.IDENTITY_VERIFICATION_DETAILS);
  const disableEditForReportTheme = (props.title === ActionTitles.REPORT_THEME_SHOW && !isEmpty(record?.reportThemeTemplateId));
  const [disableDelete, setDisableDelete] = useState(false);
  const onDeleteFailure = props.onDeleteFailure ? props.onDeleteFailure : () => { deleteCallback(props.recordName, "failure", notify); };

  return (
    <Grid container>
      {!isAdmin && <StatusMessageAlerts />}
      <Grid item container xs={12} justifyContent={'space-between'}>
        <Grid sx={pageTitle}>{props.title}</Grid>
        <Grid sx={topActionButtonsRow}>
          {props.showFilterButton === true &&
            <FilterButton
              id="list-actions-filter-button"
              variant="contained"
              sx={filterButton}
              size="small"
              disableSaveQuery={true}
            />
          }
          {props.showReportThemesButton === true && record && (
            <Button
              id="list-actions-report-themes-button"
              size="small"
              sx={{ ...topActionButtonBaseStyle() }}
              onClick={() =>
                redirect(
                  RESOURCES_BASEPATH.REPORT_THEME +
                    `?filter=${encodeURIComponent(JSON.stringify({ clientId: record.id }))}`
                )
              }
            >
              <ColorLensOutlinedIcon />
            </Button>
          )}
          {props.showViewButton === true && (
            <ShowButton
              id="list-actions-show-button"
              size="small"
              sx={{ ...topActionButtonBaseStyle() }}
              icon={<RemoveRedEyeOutlinedIcon />}
              label={ActionTitles.VIEW}
              {...props}
            />
          )}
          {props.showCreateButton === true && (
            <CreateButton
              id="list-actions-create-button"
              size="small"
              sx={{ ...topActionButtonBaseStyle() }}
              icon={<AddCircleOutlineIcon />}
              label={ActionTitles.CREATE}
              to={`${props.basePath}/create`}
              disabled={isDisabled}
            />
          )}
          {props.showEditButton === true && (
            <EditButton
              id="list-actions-edit-button"
              size="small"
              sx={{ ...topActionButtonBaseStyle() }}
              icon={<EditOutlinedIcon />}
              label={ActionTitles.UPDATE}
              disabled={isDisabled || disableEditForReportTheme}
            />
          )}          
          {props.showBundleNavigationButton === true && !isEmpty(previousClientRequestId) && (
            <Button
              id="list-actions-previous-report-button"
              size="small"
              sx={{ ...topActionButtonBaseStyle("white", "#383848", "#181822") }}
              onClick={() => redirect(`${RESOURCES_BASEPATH.REPORTS}/${previousClientRequestId}/show`)}
            >
              <WestOutlined />
            </Button>
          )}
          {props.showBundleNavigationButton === true && !isEmpty(nextClientRequestId) && (
            <Button
              id="list-actions-next-report-button"
              size="small"
              sx={{ ...topActionButtonBaseStyle("white", "#383848", "#181822"), marginLeft : "0px !important" }}
              onClick={() => redirect(`${RESOURCES_BASEPATH.REPORTS}/${nextClientRequestId}/show`)}
            >
              <EastOutlined />
            </Button>
          )}
          {props.showDeleteButton === true && (
            <CustomDeleteWithConfirmButton
              id="list-actions-delete-button"
              icon={<DeleteOutlinedIcon />}
              sx={{ ...topActionButtonBaseStyle() }}
              size="small"
              label={ActionTitles.DELETE}
              record={record}
              recordName={props.recordName}
              mutationMode="pessimistic"
              resource={props.resource}
              onSuccess={() => {
                deleteCallback(props.recordName, "success", notify, redirect, props.basePath)
                setDisableDelete(false)
              }}
              onFailure={(error) => {
                onDeleteFailure(error)
                setDisableDelete(false)
              }}
              disableDelete={disableDelete}
              setDisableDelete={setDisableDelete}
              disabled={isDisabled}
            />
          )}
          {props.ShowExportButton === true && (
            <ExportButton
              id="list-actions-export-button"
              size="small"
              maxResults={paginationContext ? paginationContext.total : 1000}
              sx={{ ...topActionButtonBaseStyle("#93002c", "#fff", "#fffafa", "#93002c", "#730023") }}
            />
          )}
          {props.showColumnsButton === true &&
            <SelectColumnsButton
              id="list-actions-select-columns-button"
              sx={{ ...topActionButtonBaseStyle("white", "#383848", "#181822") }}
              size="small"
            />
          }
        </Grid>
      </Grid>
      {props.filters && <Grid item container xs={12}>{props.filters}</Grid>}
    </Grid>
  );
}

export default ListActions;
